import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';
import {
  DATA_ROOM_ACCESS_KINDS,
  DATA_ROOM_END_REASONS,
  DataRoomOverridableReasonSchema,
} from '../deal/data-room.schemas';

// Ids and machine fields only (ADR 0015 §PII).
const dataRoomIds = {
  releaseId: z.uuid(),
  prospectId: z.uuid(),
  workspaceId: z.uuid(),
  organizationId: z.uuid(),
  propertyId: z.uuid(),
  contactId: z.uuid(),
};

export const DataRoomReleasedPayloadSchema = z.object({
  ...dataRoomIds,
  renewed: z.boolean(),
  // The Maklervertrag reason acknowledged at release (IMM-1207); null without one. Optional: events stored before
  // IMM-1207 carry no field.
  overriddenReason: DataRoomOverridableReasonSchema.nullable().optional(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type DataRoomReleasedPayload = z.infer<typeof DataRoomReleasedPayloadSchema>;

export const DataRoomReleaseEndedPayloadSchema = z.object({
  ...dataRoomIds,
  endReason: z.enum(DATA_ROOM_END_REASONS),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type DataRoomReleaseEndedPayload = z.infer<typeof DataRoomReleaseEndedPayloadSchema>;

export const DataRoomDocumentAccessedPayloadSchema = z.object({
  accessId: z.uuid(),
  releaseId: z.uuid(),
  prospectId: z.uuid(),
  workspaceId: z.uuid(),
  organizationId: z.uuid(),
  documentId: z.uuid(),
  kind: z.enum(DATA_ROOM_ACCESS_KINDS),
  occurredAt: z.iso.datetime(),
});

export type DataRoomDocumentAccessedPayload = z.infer<typeof DataRoomDocumentAccessedPayloadSchema>;
